<template>
  <vp-tooltip v-bind="tooltipProps">
    <template #target>
      <vp-button class="vp-message-template__preview icon-button small blue" :class="{ 'no-fill': !value }" :disabled="disabled" @click="update()">
        <i class="fa fa-eye" />
      </vp-button>
    </template>
  </vp-tooltip>
</template>

<script>
import VpButton from '../vp-button/VpButton.vue';
import VpTooltip from '../vp-tooltip/VpTooltip.vue';

export default {
  name: 'VpMessagePreviewToggle',
  components: { VpButton, VpTooltip },
  props: {
    value: { type: [Boolean, Number], default: false },
    disabled: { type: [Boolean, Number], default: false },
  },
  methods: {
    update() {
      const value = isNaN(this.value) ? !this.value : this.value ? 0 : 1;
      return this.$emit('input', value);
    }
  },
  computed: {
    tooltipProps() {
      return { 
        body: `Preview Mode: ${this.value ? 'On' : 'Off'}`,
        styles: { fontSize: '12px' },
      };
    }
  }
}
</script>